import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Constants } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-custom-reminder',
  templateUrl: './custom-reminder.component.html',
  styleUrls: ['./custom-reminder.component.scss']
})
export class CustomReminderComponent {
  @Input() message: any = {};
  @Input() uniqueId: string = '';
  @Output() onClose = new EventEmitter<void>();
  @Input() isTop: boolean = false;

  constructor(private commonService: CommonService) {}


  closePopup(event?: MouseEvent): void {
    event?.stopPropagation();
    const element = document.getElementById(this.uniqueId);
    if (element) {
      element.parentNode?.removeChild(element);
    }
    this.onClose.emit();
  }

  onReminderClick(event: MouseEvent): void {
    if (this.message?.type !== 'lead' || !this.message?.lead_id) {
      return;
    }

    const target = event.target as HTMLElement | null;
    if (target?.closest('.close-btn') || target?.closest('.floating-clear-all')) {
      return;
    }

    this.goToLeadDetails(event, this.message.lead_id);
  }

  goToMemberDetails(event: MouseEvent, patientId: number, participationId: number): void{
    event.stopPropagation();

    const url = `${Constants.MAIN_MEMBER_DETAILS_ROUTE}/${patientId}/${participationId}/${Constants.OVERVIEW_ROUTE}/${Constants.PROFILE_ROUTE}`;
    window.open(url, '_blank');
  }

  goToLeadDetails(event: MouseEvent, leadId: number): void {
    event.stopPropagation();

    const url = `/${Constants.MAIN_LEAD_DETAIL}/${leadId}`;
    window.open(url, '_blank');
    this.closePopup();
  }

  clearAllReminders(event?: MouseEvent): void {
    event?.stopPropagation();
    this.commonService.clearAllNotifications();
  }

}
